import { RESORT_FACILITIES } from "../helpers/constants";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import moment from "moment";

export default {
  computed: {
    tripadvisorImage() {
      const rating = this.resort.__platform_rating.toFixed(1);

      return `https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/${rating}-MCID-5.svg`;
    },
    displayingFacilities() {
      let facilities = get(this, ["resort", "inclusions_objects"], []);
      facilities = facilities.filter(
        (item) => item.list_id === RESORT_FACILITIES
      );
      facilities = orderBy(facilities, ["order", "name"], ["asc"], ["asc"]);

      return facilities.slice(0, 5);
    },
    validOffers() {
      /* Example of an offer object:
      {
          "title": "25% off Winter Offer",
          "id": 420,
          "offerTitle": "Special offer",
          "discountTag": "25% off",
          "offerDetail": "<ul><li>25% off accommodation</li><li>Seaplane transfers and breakfast included</li><li>Diving and courses can be booked at the resort&nbsp;</li></ul>",
          "originalPrice": 10594,
          "offerPrice": 8294,
          "offerColor": "purplePrimary",
          "offerPriority": 0,
          "priceDescription": "7N, 2 guests",
          "postDate": {
              "date": "2024-09-23 03:18:06"
          },
          "expiryDate": {
              "date": "2025-01-31 00:00:00"
          }
      }
      */
      let allOffers = this.resort.__odyssey_offers;
      if (!allOffers) {
        return [];
      }

      // Remove expired offers
      allOffers = allOffers.filter((offer) => {
        const expiryDate = get(offer, ["expiryDate", "date"]);
        return moment(expiryDate).isAfter(moment());
      });

      // sort by expiry date. Whichever is closest to today will be first
      allOffers = orderBy(allOffers, ["expiryDate.date"], ["asc"]);

      return allOffers;
    },
  },
  methods: {
    getOfferClass(offer) {
      const suffix = get(offer, ["offerColor"], "purplePrimary");

      return `offer--${suffix}`;
    },
  },
};
